// @ts-check
import PropertyConditionButton from 'components/Condition/PropertiesCondition/PropertyConditionButton';
import React, { useCallback } from 'react';

const PropertyConditionComponent = ({ model, value, onChange }) => {
  const onConditionsChanged = useCallback((newConditions) => {
    onChange(model, newConditions);
  }, [model, onChange]);

  return <PropertyConditionButton title={model.label} conditions={value ?? []} onConditionsChanged={onConditionsChanged} />;
};

export default PropertyConditionComponent;
